
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import {dictApi, dictInstrumentApi} from "@/api/organization";
    import TempSave from "@/components/TempSave.vue";
    import EmptyContent from "@/components/EmptyContent.vue";
    @Component({name: 'Sys_Instrument_Tree', components: {TempSave, SetTableColumns, EmptyContent}})
    export default class Home extends Vue {
        title = '器具字典';
        treeList = [] as any; //这个是处理过后的数据
        orgTreeList = [] as any; //源数据
        defaultProps = {
            children: 'children',
            label: 'name'
        }
        expandedKeys = [];
        dialog = {
            mode: "", // ADD or EDIT
            visible: false,
            node: null as any,
        }
        moveDialog = {
            visible: false,
            level: 0,
            formInstrumentId: 0,
            toInstrumentId: 0,
            treeList: [],
        }
        allSelected = [];
        loading = false;

        created() {
            this.getListInstrument();
        }
        getListInstrument() {
            this.loading = true;
            dictApi.listDictInstrument().then(r => {
                if (r.data.result === 0) {
                    const dataList = r.data.data;
                    this.orgTreeList = this.cloneData(dataList);
                    this.porjectTree(dataList, 1, "");
                    this.treeList = this.cloneData(dataList);
                    this.loading = false;
                }
            })
        }
        findExpandedNode() { // 寻找所有展开的节点id
            const list = [] as any;
            const el = this.$refs['treeList'] as any;
            this.treeList.forEach((element: any) => {
                if (el.getNode(element).expanded === true) {
                    list.push(element.id)
                }
            })
            return list
        }
        porjectTree(projectList: any, level: number, code: string) {
            projectList.forEach((project: any) => {
                project.level = level;
                project.codeV2 = (code + project.code);
                if (level === 3) {
                    project.children = null;
                } else {
                    project.children.sort((a: any, b: any) => {
                        return a.code - b.code;
                    });
                    this.porjectTree(project.children, (level + 1), project.codeV2);
                }
            })
        }
        porjectTreeV2(projectList: any, level: number, disableLevel: number) {
            projectList.forEach((project: any) => {
                project.level = level;
                if(level != disableLevel){
                    project.disabled = true;
                }
                if (level == 3) {
                    project.children = null;
                } else {
                    this.porjectTreeV2(project.children, (level + 1), disableLevel);
                }
            })
        }

        prefixInteger(num: any, n: number) {
            return num.toString().padEnd(n, "0");
        }
        operation(mode: any){
            const el = this.$refs['treeList'] as any;
            const dataArr = el.getCheckedNodes();
            if (dataArr.length == 0 && (['move', 'edit', 'del']).indexOf(mode) > -1) {
                this.$message.warning("请先勾选");
                return;
            }
            if(dataArr.length > 1){
                this.$message.warning("只能勾选一条");
                return;
            }
            const node = dataArr.length == 0 ? null : dataArr[0];
            if(mode == "move"){
                this.moveInstrumentModal(node);
            }else if(mode == 'edit'){
                this.updateInstrumentModal(node);
            }else if(mode == 'add'){
                this.addInstrumentModal(node);
            }else if(mode == 'del'){
                this.deleteInstrument(node);
            }
        }
        moveInstrumentModal(node: any){
            this.moveDialog.level = node.level;
            this.moveDialog.formInstrumentId = node.instrumentNameId;
            const treeList = this.cloneData(this.orgTreeList);
            this.porjectTreeV2(treeList, 1, node.level - 1)
            this.moveDialog.treeList = treeList;
            this.moveDialog.visible = true;
        }
        submitMoveDialog(){
            const el = this.$refs['toTreeList'] as any;
            const dataArr = el.getCheckedNodes();
            if(dataArr.length == 0){
                this.$message.warning("请先勾选");
                return;
            }
            if(dataArr.length > 1){
                this.$message.warning("只能勾选一条");
                return;
            }
            const node = dataArr[0];
            this.moveDialog.toInstrumentId = node.instrumentNameId;
            dictInstrumentApi.moveDictInstrument({
                formInstrumentNameId: this.moveDialog.formInstrumentId,
                toInstrumentNameId: this.moveDialog.toInstrumentId,
                level: this.moveDialog.level,
            }).then((r: any) => {
                if(r.data.result == 0){
                    this.closeDialog();
                    this.getListInstrument();
                }
            });
        }
        cloneData(data: any){
            return JSON.parse(JSON.stringify(data));
        }
        addInstrumentModal(parentNode: any) {
            this.dialog.mode = "ADD";
            if(parentNode == null){
                const node = this.getInitNodeData();
                node.level = 1;
                node.parentId = 0;
                this.dialog.node = node;
                this.dialog.visible = true;
            }else{
                if(parentNode.children == null && parentNode.level != 1){
                    this.$message.warning("最后一级不支持新增！")
                    return;
                }
                const node = this.getInitNodeData();
                node.level = parentNode.level;
                node.parentId = parentNode.id;
                this.dialog.node = node;
                this.dialog.visible = true;
            }

        }

        updateInstrumentModal(currentNode: any) {
            this.dialog.mode = "EDIT";
            const node = this.getInitNodeData();
            node.instrumentNameId = currentNode.instrumentNameId;
            node.name = currentNode.name;
            node.code= currentNode.code;
            node.level = currentNode.level;
            this.dialog.node = node;
            this.dialog.visible = true;
        }

        deleteInstrument(node: any){
            if(node.children != null && node.children.length > 0){
                this.$message.warning("以上器具字典已被使用不能删除！")
                return;
            }
            this.$confirm('确定要删除 【'+ node.name + '】器具字典吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                dictInstrumentApi.deleteDictInstrument({dictInstrId: node.id}).then((r: any) => {
                    if(r.data.result == 0){
                        this.getListInstrument();
                    }
                });
            }).catch(() => {
                console.log("取消")
            });



        }

        getInitNodeData(){
            return {
                parentId: 0,
                name: "",
                level: 0,
                code: "",
                instrumentNameId: 0,
            }
        }
        closeDialog(){
            this.dialog.mode = '';
            this.dialog.visible = false;
            this.dialog.node = null;

            this.moveDialog.visible = false;
            this.moveDialog.level = 0;
            this.moveDialog.formInstrumentId = 0;
            this.moveDialog.toInstrumentId = 0;
            this.moveDialog.treeList = [];
        }
        submitDialog(){
            let api = null;
            const node = this.dialog.node;
            if(this.dialog.mode == "ADD"){
                api = dictInstrumentApi.addDictInstrument({parentId: node.parentId, dictInstrName: node.name, level: node.level, code: node.code});
            }else{
                api = dictInstrumentApi.updateInstrumentName({instrumentNameId: node.instrumentNameId, dictInstrName: node.name, code: node.code, level: node.level});
            }
            this.expandedKeys = this.findExpandedNode();
            api.then((r: any) => {
                if(r.data.result == 0){
                    this.closeDialog();
                    this.getListInstrument();
                }
            });
        }
    }
